module.exports = __webpack_public_path__ + "img/UTJORD-1.2e67f5f1.jpg";